import React from 'react';
import { connect } from 'react-redux';
import {
	meProducersSelector,
	spotlightPeersSelector,
	videoBoxesSelector
} from '../../Selectors';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as appPropTypes from '../../appPropTypes';
import { withStyles } from '@material-ui/core/styles';
import Peer from '../../Containers/Peer';
import Me from '../../Containers/Me';
import * as roomActions from '../../../actions/roomActions';
import MeetingToolView from './MeetingToolView';
import HomeMeetingControls from './HomeMeetingControls';
// Component
import { firestore } from '../../../lib/firebase';
import ScreenSharing from '../Common/ScreenSharing';

/*
import {
	FULLHD_HOST_HEADER,
	FULLHD_HOST_CONTENT_WIDTH,
	FULLHD_HOST_CONTENT_HEIGHT,
	FULLHD_HOST_INNER_CONTENT_WIDTH,
	FULLHD_HOST_INNER_CONTENT_HEIGHT,
	FULLHD_HOST_INNER_CONTENT_SIDE_WIDTH,
	FULLHD_HOST_SELF_WIDTH,
	FULLHD_GUEST_CONTENT_WIDTH,
	FULLHD_GUEST_CONTENT_HEIGHT,
	FULLHD_GUEST_INNER_CONTENT_WIDTH,
	FULLHD_GUEST_INNER_CONTENT_HEIGHT,
	FULLHD_GUEST_SELF_WIDTH,
	FULLHD_NAVI_HEIGHT
} from '../../const';
*/

const FILL_RATE = 0.93;

const styles = () =>
	({
		root :
		{
			height         : '100%',
			width          : '100%',
			display        : 'flex',
			flexDirection  : 'row',
			flexWrap       : 'wrap',
			justifyContent : 'center',
			alignItems     : 'flex-end',
			alignContent   : 'center'
		},
		hiddenToolBar :
		{
			paddingTop : 0,
			transition : 'padding .5s'
		},
		showingToolBar :
		{
			transition : 'padding .5s'
		},
		leftArea :
		{
			width          : '20%',
			height         : '100%',
			display        : 'flex',
			justifyContent : 'space-between',
			flexDirection  : 'column',
			alignItems     : 'center'
		},
		leftAreaTop :
		{
			display        : 'flex',
			flexDirection  : 'column',
			height         : '64%',
			justifyContent : 'space-between'
		},
		centerArea :
		{
			width          : '60%',
			height         : '100%',
			alignItems     : 'end',
			justifyContent : 'center',
			display        : 'flex'
		},
		rightArea :
		{
			width          : '20%',
			height         : '100%',
			justifyContent : 'center',
			alignItems     : 'flex-end',
			display        : 'flex',
			textAlign      : 'center',
			zIndex         : '1'
		},
		controlBtn :
		{
			borderRadius    : '5rem',
			fontSize        : '0.6rem',
			backgroundColor : 'white',
			color           : '#adadac',
			boxShadow       : '2px 2px 4px #aaa',
			justifyContent  : 'center',
			alignItems      : 'center',
			display         : 'flex',
			flexDirection   : 'column',
			lineHeight      : 1.5,
			whiteSpace      : 'nowrap',
			aspectRatio     : 1,
			width           : '4.5rem',
			'&:hover'       :
			{
				backgroundColor : '#f50057'
			},
			'& .MuiButton-label' :
			{
				justifyContent : 'center',
				alignItems     : 'center',
				display        : 'flex',
				flexDirection  : 'column'
			}
		},
		controlBtnActive :
		{
			backgroundColor : '#9ec317',
			color           : 'white',
			boxShadow       : '2px 2px 4px inset #aaa'
		}
	});

class HomeMeetingView extends React.PureComponent
{
	constructor(props)
	{
		super(props);

		this.state = {
			swapVideo : false
		};

		this.resizeTimeout = null;

		this.peersRef = React.createRef();
	}

	updateDimensions = () =>
	{
		const {
			boxes
		} = this.props;

		const {
			current
		} = this.peersRef;

		if (!current)
			return;

		if (boxes === 0)
			return;

		const width = current.clientWidth;
		const height = current.clientHeight;

		const baseLength = width;

		let peerWidth = baseLength;

		let meWidth = baseLength;

		// 上はみ出る
		if (baseLength * 0.6 > height)
		{
			peerWidth = height;
			meWidth = height * 0.33;
		}
		else
		{
			peerWidth *= 0.6;
			meWidth *= 0.21;
		}

		// eslint-disable-next-line no-console
		console.log('width, height, baseLength', width, height, baseLength);

		this.setState({
			meWidth    : Math.ceil(FILL_RATE * meWidth),
			meHeight   : Math.ceil(FILL_RATE * meWidth),
			peerWidth  : Math.ceil(FILL_RATE * peerWidth),
			peerHeight : Math.ceil(FILL_RATE * peerWidth),
			minHeight  : height
		});
	};

	uploadCallInfo = async (startTime) =>
	{
		const {
			call,
			setRoomCall
		} = this.props;

		if (call !== null)
		{
			const data = call;

			// this.state.talkDuration;
			data.duration = Math.floor((Date.now() - startTime)/1000);
			data.duration = data.duration <= 10 ? 0 : data.duration - 10;

			await firestore.collection('calls').doc(data.id)
				.update(data)
				.catch((e) =>
				{
					console.error(e); // eslint-disable-line no-console
				});

			setRoomCall(data);
		}
	};

	componentDidMount()
	{
		// window.resize event listener
		window.addEventListener('resize', () =>
		{
			// clear the timeout
			clearTimeout(this.resizeTimeout);

			// start timing for event "completion"
			this.resizeTimeout = setTimeout(() => this.updateDimensions(), 250);
		});

		this.updateDimensions();

		// this.durationTimer = setTimeout(() => this.updateDuration(), 1000);

		if (this.props.call?.guestInput1?.value || this.props.call?.guestInput2?.value)
		{
			this.props.updateMemo({
				guestInput1 : { ...this.props.call.guestInput1 },
				guestInput2 : { ...this.props.call.guestInput2 }
			});
		}
	}

	componentWillUnmount()
	{
		const {
			callStartTime
		} = this.props;

		window.removeEventListener('resize', this.updateDimensions);

		this.uploadCallInfo(callStartTime);
	}

	componentDidUpdate(prevProps)
	{
		if (prevProps !== this.props)
			this.updateDimensions();

		const { settings } = prevProps;

		// facing mode changed
		if (settings.facingModeWebCam !== this.props.settings.facingModeWebCam)
		{
			if (this.props.settings.facingModeWebCam === 'environment')
			{

				// eslint-disable-next-line react/no-did-update-set-state
				this.setState({
					swapVideo : true
				});
			}
			else
			{
				// eslint-disable-next-line react/no-did-update-set-state
				this.setState({
					swapVideo : false
				});
			}
		}
	}

	finishMeeting = () =>
	{
		const {
			peers,
			roomClient,
			setMakeCallEnd
		} = this.props;

		roomClient.kickPeer(Object.keys(peers)[0]);
		roomClient.clearChat();
		setMakeCallEnd(true);
	}

	render()
	{
		const {
			advancedMode,
			spotlightsPeers,
			screenProducer,
			toolbarsVisible,
			permanentTopBar,
			buttonControlBar,
			hideSelfView,
			classes
		} = this.props;

		const meStyle =
		{
			'width'  : this.state.meWidth ? this.state.meWidth : 0,
			'height' : this.state.meHeight ? this.state.meHeight : 0
		};

		const style =
		{
			'width'  : this.state.peerWidth ? this.state.peerWidth : 0,
			'height' : this.state.peerHeight ? this.state.peerHeight : 0
		};

		return (
			<div
				className={classnames(
					classes.root,
					toolbarsVisible || permanentTopBar ?
						classes.showingToolBar : classes.hiddenToolBar,
					buttonControlBar ? classes.buttonControlBar : null
				)}
				ref={this.peersRef}
			>
				{ screenProducer ?
					<ScreenSharing advancedMode={advancedMode} />
					:
					<>
						<div className={classes.leftArea} style={{ height: style.height }}>
							<div className={classes.leftAreaTop}>
								<HomeMeetingControls finishMeeting={this.finishMeeting}/>
							</div>
							{ !hideSelfView &&
							<>
								{ !this.state.swapVideo ?
									<Me
										advancedMode={advancedMode}
										spacing={6}
										style={meStyle}
										width={this.state.meWidth}
										height={this.state.meHeight}
									/>
									:
									<>
										{ spotlightsPeers.map((peer) =>
										{
											return (
												<Peer
													key={peer}
													advancedMode={advancedMode}
													id={peer}
													style={meStyle}
													enableLayersSwitch
													width={this.state.meWidth}
													height={this.state.meHeight}
												/>
											);
										})}

									</>

								}
							</>
							}
						</div>
						<div className={classes.centerArea}>
							{ !this.state.swapVideo ?
								<>
									{ spotlightsPeers.map((peer) =>
									{
										return (
											<Peer
												key={peer}
												advancedMode={advancedMode}
												id={peer}
												style={style}
												enableLayersSwitch
												width={this.state.peerWidth}
												height={this.state.peerHeight}
											/>
										);
									})}
								</>
								:
								<Me
									advancedMode={advancedMode}
									spacing={6}
									style={style}
									width={this.state.peerWidth}
									height={this.state.peerHeight}
								/>

							}
						</div>
						<div className={classes.rightArea}>
							<MeetingToolView
								style={style}
							/>
						</div>
					</>
				}
			</div>
		);
	}
}

HomeMeetingView.propTypes =
{
	peers            : PropTypes.object.isRequired,
	roomClient       : PropTypes.object.isRequired,
	advancedMode     : PropTypes.bool,
	boxes            : PropTypes.number,
	spotlightsPeers  : PropTypes.array.isRequired,
	screenProducer   : appPropTypes.Producer,
	toolbarsVisible  : PropTypes.bool.isRequired,
	hideSelfView     : PropTypes.bool.isRequired,
	permanentTopBar  : PropTypes.bool.isRequired,
	buttonControlBar : PropTypes.bool.isRequired,
	toolAreaOpen     : PropTypes.bool.isRequired,
	aspectRatio      : PropTypes.number.isRequired,
	classes          : PropTypes.object.isRequired,
	call             : PropTypes.object.isRequired,
	callStartTime    : PropTypes.number.isRequired,
	setRoomCall      : PropTypes.func.isRequired,
	setCallStartTime : PropTypes.func.isRequired,
	setMakeCallEnd   : PropTypes.func.isRequired,
	updateMemo       : PropTypes.func.isRequired,
	settings         : PropTypes.object.isRequired
};

const mapStateToProps = (state) =>
{
	return {
		peers            : state.peers,
		boxes            : videoBoxesSelector(state),
		spotlightsPeers  : spotlightPeersSelector(state),
		...meProducersSelector(state),
		toolbarsVisible  : state.room.toolbarsVisible,
		hideSelfView     : state.room.hideSelfView,
		permanentTopBar  : state.settings.permanentTopBar,
		buttonControlBar : state.settings.buttonControlBar,
		toolAreaOpen     : state.toolarea.toolAreaOpen,
		aspectRatio      : state.settings.aspectRatio,
		call             : state.room.call,
		callStartTime    : state.room.callStartTime,
		settings         : state.settings
	};
};

const mapDispatchToProps = (dispatch) =>
{
	return {
		setRoomCall : (call) =>
		{
			dispatch(roomActions.setRoomCall(call));
		},
		setCallStartTime : (timestamp) =>
		{
			dispatch(roomActions.setRoomCallStartTime(timestamp));
		},
		setMakeCallEnd : (bool) =>
		{
			dispatch(roomActions.setMakeCallEnd(bool));
		},
		updateMemo : (memo) =>
		{
			dispatch(roomActions.updateMemo(memo));
		}
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.peers === next.peers &&
				prev.producers === next.producers &&
				prev.consumers === next.consumers &&
				prev.room.spotlights === next.room.spotlights &&
				prev.room.toolbarsVisible === next.room.toolbarsVisible &&
				prev.room.hideSelfView === next.room.hideSelfView &&
				prev.settings.audioMuted === next.settings.audioMuted &&
				prev.settings.videoMuted === next.settings.videoMuted &&
				prev.settings.aspectRatio === next.settings.aspectRatio &&
				prev.settings.holding === next.settings.holding &&
				prev.settings.facingModeWebCam === next.settings.facingModeWebCam &&
				prev.room.call === next.room.call &&
				prev.room.callStartTime === next.room.callStartTime
			);
		}
	}
)(withStyles(styles, { withTheme: true })(HomeMeetingView));
